import FetchUtils from '../utils/fetch.utils';

export default class SettingsService {
  static BASE_URL = `${process.env.PREACT_APP_API_DOMAIN_SETTINGS}/api/settings`;

  static getHome = async () => {
    return FetchUtils.get(`${SettingsService.BASE_URL}/home`);
  };

  static getWallet = async () => {
    return FetchUtils.get(`${SettingsService.BASE_URL}/wallet`);
  };

  static getOnboarding = async organizationCode => {
    return FetchUtils.get(
      `${SettingsService.BASE_URL}/onboarding?organizationCode=${organizationCode}`,
    );
  };

  static getOrganization = async params => {
    return FetchUtils.get(
      `${SettingsService.BASE_URL}/organizations${FetchUtils.getQueryParams(
        params,
      )}`,
    );
  };
}
